<template>
<div style="width:100%">
  <template v-for="(item, index) in items_correos">
    <div :key="index" v-if="visibleItem(item.id_usuario)">
        <v-row no-gutters>
          <v-col cols="12" md="1" align-self="center" class="text-center">
            <v-avatar :color="colores.primario" size="30" class="white--text">{{ (index + 1) }}</v-avatar>
          </v-col>
          <v-col cols="12" md="10" align-self="center">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ rec_funciones_minusculas(item.usuario.usuario) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="1" align-self="center" class="text-center">
            <v-btn @click="agregar(item)" icon :color="colores.primario"><v-icon>mdi-plus</v-icon></v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
    </div>
  </template>
</div>
</template>

<script>
import recFunciones from '@/js/rec_funciones.js'
export default {
  name: 'escalamientosComponent',
  components: {

  },
  mixins: [recFunciones],
  props: ['colores', 'items_correos', 'items_escalamiento'],
  data: () => ({
  }),
  methods: {
    agregar (item) {
      this.items_escalamiento.push({ id_usuario: item.id_usuario, area: item.area.descripcion, area_id: item.area.id, correo: item.usuario.usuario, descripcion: '', items_archivos: [] })
    },
    visibleItem (pidUsuario) {
      let isExiste = true
      const users = this.items_escalamiento.filter(item => { return (item.id_usuario === pidUsuario) })
      if (users.length >= 1) {
        isExiste = false
      } else {
        isExiste = true
      }
      return isExiste
    }

  }
}
</script>
